import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from '@nazka/nazka.mapframe.components';
import { useAuth } from 'react-oidc-context';
import {
  faUsers,
  faRectanglesMixed,
  faTrophy,
  faBallotCheck, 
} from '@fortawesome/pro-light-svg-icons';

import './admin-sidebar.styl';

const navigationItems = [
  {
    path: '/admin',
    label: 'Overview',
    icon: faRectanglesMixed,
  },
  {
    path: '/admin/plans',
    label: 'Plans',
    icon: faBallotCheck,
  },
  {
    path: '/admin/stories',
    label: 'Stories',
    icon: faTrophy,
  },
  {
    path: '/admin/users',
    label: 'Users',
    icon: faUsers,
    admin: true,
  },
];

function AdminSidebar() {
  const { user } = useAuth();

  const location = useLocation();
  
  const isAdmin = user?.profile?.['cognito:groups']?.includes('administrators');

  return (
    <div className="admin-sidebar">
      <nav className="admin-sidebar__nav">
        <ul className="admin-sidebar__nav-list">
          {navigationItems.filter(item => !item.admin || isAdmin).map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path} className="admin-sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className={`admin-sidebar__nav-link ${
                    isActive ? 'admin-sidebar__nav-link--active' : ''
                  }`}
                >
                  <Icon className="admin-sidebar__nav-icon" size="24px" icon={item.icon} />
                  <span className="admin-sidebar__nav-label">{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

export default AdminSidebar;